export const ACTION_CLOSE_MAISON_CHAT = 'closemaisonchat';
export const ACTION_EDIT_QA = 'editqa';
export const ACTION_EDIT_QA_NEW_TAB = 'editqanewtab';
export const ACTION_EDIT_CONFIGURATION = 'editconfiguration';
export const ACTION_COPY_QUERY = 'copyquery';
export const ACTION_TOGGLE_ADMIN_PANEL = 'toggleadminpanel';
export const ACTION_CLOSE_QA = 'closeqa';
export const ACTION_QA_EDITOR_READY = 'qaeditorready';
export const ACTION_SIGNOUT = 'signout';
export const ACTION_AUTHENTICATED = 'authenticated';
export const ACTION_LOG_ANALYTICS_EVENT = 'loganalyticsevent';
export const SHOW_ADMIN_FLYOUT = 'SHOW_ADMIN_FLYOUT';
export const SHOW_TONE_EDITOR = 'SHOW_TONE_EDITOR';
export const SHOW_QA_EDITOR = 'SHOW_QA_EDITOR';
export const SHOW_CONFIG_EDITOR = 'SHOW_CONFIG_EDITOR';
export const ACTION_UPDATE_LOCALE = 'updatelocale';
export const ACTION_UPDATE_SESSION_ID = 'updatesessionid';
export const ACTION_OPEN_PRIVACY_POLICY = 'openprivacypolicy';
export const ACTION_EXECUTE_BOOK_ROOM = 'EXECUTE_BOOK_ROOM';  // This action is used to let inject function know to execute the book action on the client website
export const DEFAULT_HERO_MESSAGE = 'Ask, book, and schedule anything';
export const DEFAULT_CHAT_DISPLAY_NAME = 'Concierge';
export const DEFAULT_JUST_NOW = 'Just now';
export const USER_ROLE = 'user';
export const ASSISTANT_ROLE = 'assistant';
export const DEFAULT_LOCALE = 'en_US';
export const API_PATH = '/api';
export const CHAT_WINDOW = 'chat window';   // source for the analytics
export const CLIENT_SITE = 'client site';

// Analytics events
export const EVENT_CLIENT_SITE_LOADED = 'client_site_loaded';
export const EVENT_CLIENT_DATA_LOADED = 'client_data_loaded';
export const EVENT_MCBS_INITIALIZED = 'chat_initialized';
export const EVENT_SUGGESTION_MESSAGE_DISPLAYED = 'chat_invitation_displayed';
export const EVENT_SUGGESTION_MESSAGE_CLOSED = 'chat_invitation_closed';
export const EVENT_CHAT_ICON_CLICKED = 'chat_icon_clicked';
export const EVENT_CHAT_WINDOW_OPENED = 'chat_window_opened';
export const EVENT_CHAT_WINDOW_CLOSED = 'chat_window_closed';
export const EVENT_CHAT_ICON_INJECTED = 'chat_icon_injected';
export const EVENT_CHAT_ICON_REMOVED = 'chat_icon_removed';
export const EVENT_CHAT_ICON_REPOSITIONED = 'chat_icon_repositioned';
export const EVENT_CHAT_EXISTING_SESSION_REQUESTED = 'chat_existing_session_requested';
export const EVENT_CHAT_ADMIN_SESSION_INITIATED = 'chat_admin_session_initiated';
export const EVENT_CHAT_ADMIN_SESSION_TERMINATED = 'chat_admin_session_terminated';
export const EVENT_CHAT_QUERY_REQUEST = 'chat_query_request';
export const EVENT_CHAT_LOCALE_UPDATED = 'chat_locale_updated';
export const EVENT_CHAT_EDIT_BUTTON_CLICKED = 'chat_message_edit_button_clicked';
export const EVENT_CHAT_COPY_BUTTON_CLICKED = 'chat_message_copy_button_clicked';
export const EVENT_ADMIN_FLYOUT_REQUESTED = 'admin_flyout_requested';
export const EVENT_ADMIN_FLYOUT_OPENED = 'admin_flyout_opened';
export const EVENT_ADMIN_WINDOW_OPENED = 'admin_window_opened';
export const EVENT_ADMIN_FLYOUT_CLOSED = 'admin_flyout_closed';
export const EVENT_BOOK_NOW_ACTION_REQUESTED = 'book_now_action_requested';
export const EVENT_CHAT_FIRST_QUERY = 'chat_first_query';
/*
    All exceptions are logged in this analytics event
    Add parameters
        - source - source of exception (client site, chat window, server, qa editor, etc)
        - message - exception message
        - clientid - optional
        - sessionid - optional
        - analyticssessionid - Trace the session through multiple windows and iframes 
*/
export const EVENT_EXCEPTION = 'exception';